import type { AddressBookEntry } from './addressBookTypes'

const toNormalizedText = (value: string) => value.trim().replace(/\s+/g, ' ').toLowerCase()

export const toAddressSignature = (
  entry: Pick<AddressBookEntry, 'firstName' | 'lastName' | 'addressLine' | 'city' | 'postalCode' | 'province' | 'country'>,
) =>
  [
    toNormalizedText(entry.firstName),
    toNormalizedText(entry.lastName),
    toNormalizedText(entry.addressLine),
    toNormalizedText(entry.city),
    toNormalizedText(entry.postalCode),
    toNormalizedText(entry.province),
    toNormalizedText(entry.country),
  ].join('|')

export const createAddressId = () => `adr_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`

export const normalizeAddressBook = (entries: AddressBookEntry[]) => {
  let shippingDefaultAssigned = false
  let billingDefaultAssigned = false

  return entries
    .map((entry) => {
      const useShipping = entry.useShipping || entry.defaultShipping
      const useBilling = entry.useBilling || entry.defaultBilling

      const defaultShipping = useShipping && entry.defaultShipping && !shippingDefaultAssigned
      const defaultBilling = useBilling && entry.defaultBilling && !billingDefaultAssigned

      if (defaultShipping) shippingDefaultAssigned = true
      if (defaultBilling) billingDefaultAssigned = true

      return {
        ...entry,
        useShipping,
        useBilling,
        defaultShipping,
        defaultBilling,
      }
    })
    .filter((entry) => entry.addressLine.trim().length > 0)
}
